import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button
} from "@material-ui/core";

// styles
// import useStyles from "./styles";
import useStyles from "../../../src/themes/makeStyles";
// components
import PageTitle from "./PageTitle/PageTitle";
import { Typography } from "./Wrappers/Wrappers";

import InvoicesDashboardTable from "./components/TableInvoices/TableInvoiceComponent";
import TablesftoReportComponent from "./components/TableInvoices/TablesftoReportComponent";
import TablesSftoThresholdComponent from "./components/TableInvoices/TablesftoThresholdComponent"
import TablegpwisReportComponent from "./components/TableInvoices/TablegpwisReportComponent";
import SalesOrdersDashboardTable from "./components/TableInvoices/TableSalesOrderComp";
import TableSftoJobDetailsComponent from "./components/TableInvoices/TableSftoJobDetailsComponent";
import TableGpwisJobDetailsComponent from "./components/TableInvoices/TableGpwisJobDetailsComponent";
import DateRangePicker from "../../components/DateRangePicker";
import { default as Apiservices } from "../../common";
import { Paper } from "@material-ui/core";
import { PowerBIEmbed } from 'powerbi-client-react';
import {
  useForm,
  Controller
} from "react-hook-form";

import clsx from "clsx";
import moment from "moment";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import BarCharter from './components/TableInvoices/BarChartComponent'
import AutoCompletecontrler from "../../components/AutoComplete";
import DateComponent from "../../components/DashboardDateComponent";
import FormValidationErrorMessage from "../../components/FormValidationErrorMessage";
import ExecutiveDashboard from "./DailyPositionReport/executiveDashboard";
import BuildURL from '../../constants/serverCredintials';
var CurrencyFormat = require('react-currency-format');

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Dashboard() {
  const [resetvalues, setResetvalues] = React.useState(true);
  const [resetvaluesGpwis, setResetvaluesGpwis] = React.useState(true);
  const [allInvoices, setAllInvoices] = useState([]);
  const [sftoReports, setSftoReports] = useState([]);
  const [sftoThresholdList, setSftoThresholdList] = useState([]);
  const [gpwisReports, setGpwisReports] = useState([]);
  const [allSftoJobDetails, setAllSftoJobDetails] = useState([]);
  const [allGpwisJobDetails, setAllGpwisJobDetails] = useState([]);
  const [allSalesOrders, setAllSalesOrders] = useState([]);
  const [sftorrEndDate, setSftorrEndDate] = useState();
  const [sftorrStartDate, setSftorrStartDate] = useState();
  const [gpwisrrEndDate, setGpwisrrEndDate] = useState();
  const [gpwisrrStartDate, setGpwisrrStartDate] = useState();
  const [disableSftoButton, setDisableSftoButton] = useState(true);
  const [disableGpwisButton, setDisableGpwisButton] = useState(true);
  const [loading, setLoading] = useState(true);
  const [gpwisLoading, setGpwisLoading] = React.useState(true);
  const [dashBoardDetails, setDashboardDetails] = useState([]);
  const [value, setValue1] = React.useState(2);  // -- #TODO chnge thos value to 2
  const [doCountByStatus, setDoCountByStatus] = useState([]);
  const [doCountByStatus2, setDoCountByStatus2] = useState([]);
  const [executiveData, setExecutiveData] = useState('');
  const [finYearOptions, setFinYearOptions] = useState([]);
  const [currentFinYear, setCurrentFinYear] = useState('');

  const handleChange = (event, newValue) => {
    setValue1(newValue);
  };
  const methods = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    // defaultValues: getHeaderInfoDefaultData(modeOfDispatch),
  });

  const {
    control,
    errors,
    handleSubmit
  } = methods;

  const getFinYearDropdown = () => {
    let finYearsArr = []
    let yearsLength = 5;
    let currentYear = new Date().getFullYear();
    for (let i = 0; i < yearsLength; i++) {
      let next = currentYear + 1;
      let year = currentYear + '-' + next.toString().slice(-2);
      finYearsArr.push(year);
      currentYear--;
    }
    setFinYearOptions(finYearsArr)
    let today = new Date();
    let curMonth = moment(new Date()).format('MM');
    let currentFinYear = "";
    if (Number(curMonth) > 3) {
      var nextYr1 = (today.getFullYear() + 1);
      currentFinYear = today.getFullYear() + "-" + nextYr1;
    } else {
      var nextYr2 = today.getFullYear();
      currentFinYear = (today.getFullYear() - 1) + "-" + nextYr2;
    }
    setCurrentFinYear(currentFinYear)
  }

  const handleReceiveMessageFromParent = (event) => {
    const receivedMessage = event.data;
    if (receivedMessage.token && receivedMessage.user_email)
      handleMessage(receivedMessage);
  };

  const handleMessage = async (e) => {
    sessionStorage.setItem('token', e.token);
    sessionStorage.setItem('user_email', e.user_email);

    let userCredentials = { user_email: e.user_email.toLowerCase() };
    const TokenResponse = await Apiservices.getUserToken(userCredentials);

    if (TokenResponse && TokenResponse.issuccess === 1) {
      sessionStorage.setItem("token", TokenResponse.token);
      fetch(TokenResponse);
    }
  }

  // Unable to pass the token after logged in, So
  // Refresh the dashboard page on first time loading after logged in
  useEffect(() => {
    if (sessionStorage.getItem("isLoggedIn") === "Yes") {
      sessionStorage.removeItem("isLoggedIn")
      window.location.reload(false);
    }
  }, [])

  let fetch = async (e) => {
    sessionStorage.setItem('token', e?.token ? e.token : sessionStorage.getItem('token'));
    sessionStorage.setItem('user_email', e?.user_email ? e.user_email : sessionStorage.getItem('user_email'));
    let fromDate, endDate;

    if (moment(new Date()).format("YYYY-MM-DD") >= `${new Date().getFullYear()}-04-01`) {
      fromDate = `${new Date().getFullYear()}-04-01`
      endDate = `${new Date().getFullYear() + 1}-03-31`
    } else {
      fromDate = `${new Date().getFullYear() - 1}-04-01`
      endDate = `${new Date().getFullYear()}-03-31`
    }
    let currentDate = moment(new Date()).format('YYYY-MM-DD');
    let dates = {
      from_date: fromDate,
      end_date: endDate,
      from_month: `${new Date().getFullYear()}-${moment(new Date()).format("MM")}-01`,
      end_month: currentDate
    }
    const dashboardResponse = await Apiservices.getDashboardData(dates, e?.token);

    if (dashboardResponse) {
      setDashboardDetails(dashboardResponse)
    }
    const dashboardStatus = await Apiservices.getDashboardStatusDetails(dates, e?.token);
    if (dashboardStatus && dashboardStatus[0]) {
      setDoCountByStatus(dashboardStatus[0]['sfto']);
      setDoCountByStatus2(dashboardStatus[0]['gpwis']);
    }
    let InvoicesSalesOrders = await Apiservices.getDashboardInvoiceDetails(dates, e?.token);
    setAllInvoices(InvoicesSalesOrders[0].sftoInvoiceCount);
    setAllSalesOrders(InvoicesSalesOrders[0].gpwisInvoiceCount);
    let obj = {
      rr_start_date: '2009-01-01',
      rr_end_date: '2070-01-01'
    }
    try {
      let InvoicesSalesReports = await Apiservices.getDashboardSFTOReports(dates, e?.token);
      setSftoReports(InvoicesSalesReports.Records[0]);      
    } catch (error) {      
    }
    let thresholdlistRes = await Apiservices.getThresholdMasterlist(null, e?.token);
    setSftoThresholdList(thresholdlistRes.records);
    let InvoicesGPWISReports = await Apiservices.getDashboardGPWISReports(dates, e?.token);
    setGpwisReports(InvoicesGPWISReports.Records[0]);

    let sftoJobDetails = await Apiservices.getDashboardSFTOJobDetails(obj, e?.token);
    setAllSftoJobDetails(sftoJobDetails.Records[0]);
    setLoading(false);
    let gpwisJobDetails = await Apiservices.getDashboardGPWISJobDetails(obj, e?.token);
    setAllGpwisJobDetails(gpwisJobDetails.Records[0]);

    let date = moment(new Date()).format('YYYY-MM-DD')
    handleDateChange(date, e?.token);
    setGpwisLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFinYearDropdown();

    if (window.top === window.self) {
      fetch();
      let date = moment(new Date()).format('YYYY-MM-DD')
      handleDateChange(date);
    }

    window.addEventListener('message', handleReceiveMessageFromParent);
    const responseMessage = 'Hello from the iframe!';
    window.parent.postMessage(responseMessage, window.origin);
    return () => {
      // Clean up the event listener
      window.removeEventListener('message', handleReceiveMessageFromParent);
    };
  }, []);
  var classes = useStyles();
  // var classes = useStylesTwo();

  const getMaxDate = () => {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 7);
    return currentDate;
  }

  const handleSearchCriteriaSubmit = async (submitteddata) => {
    let queryparams = {};
    let rr_start_end_dates = submitteddata.rr_start_end_date
      ? submitteddata.rr_start_end_date.split("To")
      : null;
    queryparams.rr_start_date = rr_start_end_dates
      ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
      : null;
    queryparams.rr_end_date = rr_start_end_dates
      ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
      : null;
    setLoading(true);
    let listJobDetails = await Apiservices.getDashboardSFTOJobDetails(queryparams);
    setAllSftoJobDetails(listJobDetails.Records[0]);
    if (listJobDetails.Records[0] == null) {
      setDisableSftoButton(true);
    } else {
      setDisableSftoButton(false);
    }
    setLoading(false);
  };

  const handleGpwisSearchCriteriaSubmit = async (submitteddata) => {
    let queryparams = {};
    let rr_start_end_dates = submitteddata.rr_start_end_date
      ? submitteddata.rr_start_end_date.split("To")
      : null;
    queryparams.rr_start_date = rr_start_end_dates
      ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
      : null;
    queryparams.rr_end_date = rr_start_end_dates
      ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
      : null;
    setGpwisLoading(true);
    let listJobDetails = await Apiservices.getDashboardGPWISJobDetails(queryparams);
    setAllGpwisJobDetails(listJobDetails.Records[0])
    if (listJobDetails.Records[0] == null) {
      setDisableGpwisButton(true);
    } else {
      setDisableGpwisButton(false);
    }
    setGpwisLoading(false);
  };

  const resetFormGpwis = async () => {
    setGpwisLoading(true);
    setResetvaluesGpwis(!resetvaluesGpwis);
    setDisableGpwisButton(true);
    let obj = {
      rr_start_date: '2009-01-01',
      rr_end_date: '2070-01-01'
    }
    let joblist = await Apiservices.getDashboardGPWISJobDetails(obj);
    setAllGpwisJobDetails(joblist.Records[0]);
    setGpwisLoading(false);
  };

  const resetForm = async () => {
    setResetvalues(!resetvalues);
    setDisableSftoButton(true);
    let obj = {
      rr_start_date: '2009-01-01',
      rr_end_date: '2070-01-01'
    }
    setLoading(true);
    let joblist = await Apiservices.getDashboardSFTOJobDetails(obj);
    setAllSftoJobDetails(joblist.Records[0]);
    setLoading(false);
  };

  const getCount = (vertical, type) => {
    let infoObj = dashBoardDetails && dashBoardDetails.find(item => item.record_name === vertical)
    return infoObj && infoObj[type] ? infoObj[type] : 0
  }

  const generateReport = async () => {
    let startDate = null, endDate = null;
    if (sftorrStartDate) {
      startDate = sftorrStartDate;
    } else {
      startDate = '2012-01-01';
    }
    if (sftorrEndDate) {
      endDate = sftorrEndDate;
    } else {
      endDate = new Date(moment(new Date).format("YYYY-MM-DD"))
    }
    Apiservices.downloadDashboardJobDetails(startDate, endDate);
  };

  const generateGpwisReport = async () => {
    let startDate = null, endDate = null;
    if (gpwisrrStartDate) {
      startDate = gpwisrrStartDate;
    } else {
      startDate = '2012-01-01';
    }
    if (gpwisrrEndDate) {
      endDate = gpwisrrEndDate;
    } else {
      endDate = new Date(moment(new Date).format("YYYY-MM-DD"))
    }
    Apiservices.downloadDashboardGpwisJobDetails(startDate, endDate);
  };

  const handleDateChange = async (date, psd_token) => {
    let splitYear = date.split("-")[0], splitMonth = date.split("-")[1], splitDay = date.split("-")[2];

    let fromDate
    let endDate
    if (moment(new Date()).format("YYYY-MM-DD") >= `${new Date().getFullYear()}-04-01`) {
      fromDate = `${new Date().getFullYear()}-04-01`
      endDate = `${new Date().getFullYear() + 1}-03-31`
    } else {
      fromDate = `${new Date().getFullYear() - 1}-04-01`
      endDate = `${new Date().getFullYear()}-03-31`
    }

    let currentMonthDate = new Date(date), previousDate = new Date(date);
    if (currentMonthDate.getDate() == '1' || currentMonthDate.getDate() == '01') {
      currentMonthDate.setDate(currentMonthDate.getDate() - 1);
      currentMonthDate = moment(currentMonthDate).format('YYYY-MM-DD');
    } else {

      currentMonthDate = moment(currentMonthDate).format('YYYY-MM-DD');
    }
    previousDate.setDate(previousDate.getDate() - 1);
    previousDate = moment(previousDate).format('YYYY-MM-DD');
    let data = {
      date: date,
      from_date: fromDate,
      end_date: endDate,
      from_month: `${splitYear}-${splitMonth}-01`,
      end_month: previousDate,
      current_month_from_date: currentMonthDate
    }
    const response = await Apiservices.getExecutiveDashboardData(data, psd_token)
    let mapedData = {}

    response.records && response.records.length > 0 && response.records.map((item, index) => {
      if (item.parameter == "TARGET AS PER PROJECTION") {
        mapedData['sfto_target_as_per_project_frequency'] = item.frequency_period;
        mapedData.sfto_target_as_per_project_cumm_ntkm = item.cumm_ntkm;
        mapedData.sfto_target_as_per_project_ntkm_on_date = item.ntkm_on_date;
        mapedData.sfto_target_as_per_project_monthly_rev = item.monthly_rev_cumm;
        mapedData.sfto_target_as_per_project_rev = item.rev_as_on_date;
        mapedData.sfto_target_as_per_project_job_id = item.job_id;
      }
      if (item.parameter == "ON WHEELS") {
        mapedData.sfto_on_wheels_frequency = item.frequency_period;
        mapedData.sfto_on_wheels_cumm_ntkm = item.cumm_ntkm;
        mapedData.sfto_on_wheels_ntkm_on_date = item.ntkm_on_date;
        mapedData.sfto_on_wheels_monthly_rev = item.monthly_rev_cumm;
        mapedData.sfto_on_wheels_rev = item.rev_as_on_date;
        mapedData.sfto_on_wheels_job_id = item.job_id;
      }
      if (item.parameter == "RUNNING AVERAGE") {
        mapedData.sfto_running_average_frequency = item.frequency_period;
        mapedData.sfto_running_average_cumm_ntkm = item.cumm_ntkm;
        mapedData.sfto_running_average_ntkm_on_date = item.ntkm_on_date;
        mapedData.sfto_running_average_monthly_rev = item.monthly_rev_cumm;
        mapedData.sfto_running_average_rev = item.rev_as_on_date;
        mapedData.sfto_running_average_job_id = item.job_id;
      }
      if (item.parameter == "CUMM TARGET") {
        mapedData.sfto_cumm_target_frequency = item.frequency_period;
        mapedData.sfto_cumm_target_cumm_ntkm = item.cumm_ntkm;
        mapedData.sfto_cumm_target_ntkm_on_date = item.ntkm_on_date;
        mapedData.sfto_cumm_target_monthly_rev = item.monthly_rev_cumm;
        mapedData.sfto_cumm_target_rev = item.rev_as_on_date;
        mapedData.sfto_cumm_target_job_id = item.job_id;
      }
      if (item.parameter == "TARGET TO BE ACHIVED") {
        mapedData.sfto_target_to_be_achived_frequency = item.frequency_period;
        mapedData.sfto_target_to_be_achived_cumm_ntkm = item.cumm_ntkm;
        mapedData.sfto_target_to_be_achived_ntkm_on_date = item.ntkm_on_date;
        mapedData.sfto_target_to_be_achived_monthly_rev = item.monthly_rev_cumm;
        mapedData.sfto_target_to_be_achived_rev = item.rev_as_on_date;
        mapedData.sfto_target_to_be_achived_job_id = item.job_id;
      }
      if (item.parameter == "CUMM ACTUAL") {
        mapedData.sfto_cumm_actual_frequency = item.frequency_period;
        mapedData.sfto_cumm_actual_cumm_ntkm = item.cumm_ntkm;
        mapedData.sfto_cumm_actual_ntkm_on_date = item.ntkm_on_date;
        mapedData.sfto_cumm_actual_monthly_rev = item.monthly_rev_cumm;
        mapedData.sfto_cumm_actual_rev = item.rev_as_on_date;
        mapedData.sfto_cumm_actual_job_id = item.job_id;
      }
      if ((item.parameter == "PROJECTED LOAD TODAY") && (item.schemetype == "SFTO")) {
        mapedData.sfto_projected_load_today_frequency = item.frequency_period;
        mapedData.sfto_projected_load_today_count = item.value;
        mapedData.sfto_projected_load_today_rake_num = item.rake_number;
        mapedData.sfto_projected_load_today_job_id = item.job_id;
      }
      if ((item.parameter == "PROJECTED LOAD TODAY") && (item.schemetype == "GPWIS")) {
        mapedData.gpwis_projected_load_today_frequency = item.frequency_period;
        mapedData.gpwis_projected_load_today_count = item.value;
        mapedData.gpwis_projected_load_today_rake_num = item.rake_number;
        mapedData.gpwis_projected_load_today_job_id = item.job_id;
      }
      if ((item.parameter == "EMPTY IN PLANT") && (item.schemetype == "SFTO")) {
        mapedData.sfto_empty_in_plant_frequency = item.frequency_period;
        mapedData.sfto_empty_in_plant_count = item.value;
        mapedData.sfto_empty_in_plant_rake_num = item.rake_number;
        mapedData.sfto_empty_in_plant_job_id = item.job_id;
      }
      if ((item.parameter == "EMPTY IN PLANT") && (item.schemetype == "GPWIS")) {
        mapedData.gpwis_empty_in_plant_frequency = item.frequency_period;
        mapedData.gpwis_empty_in_plant_count = item.value;
        mapedData.gpwis_empty_in_plant_rake_num = item.rake_number;
        mapedData.gpwis_empty_in_plant_job_id = item.job_id;
      }
      if ((item.parameter == "LOADS IN PLANT YESTERDAY") && (item.schemetype == "GPWIS")) {
        mapedData.gpwis_loads_in_plant_yesterday_frequency = item.frequency_period;
        mapedData.gpwis_loads_in_plant_yesterday_count = item.value;
        mapedData.gpwis_loads_in_plant_yesterday_rake_num = item.rake_number;
        mapedData.gpwis_loads_in_plant_yesterday_job_id = item.job_id;
      }

      if (item.parameter == "LOADS IN PLANT") {
        mapedData.sfto_loads_in_plant_frequency = item.frequency_period;
        mapedData.sfto_loads_in_plant_count = item.value;
        mapedData.sfto_loads_in_plant_rake_num = item.rake_number;
        mapedData.sfto_loads_in_plant_job_id = item.job_id;
      }
      if (item.parameter == "EMPTY ON RUN" && (item.schemetype == "GPWIS")) {
        mapedData.gpwis_empty_on_run_frequency = item.frequency_period;
        mapedData.gpwis_empty_on_run_count = item.value;
        mapedData.gpwis_empty_on_run_rake_num = item.rake_number;
        mapedData.gpwis_empty_on_run_job_id = item.job_id;
      }
      if (item.parameter == "EMPTY ON RUN" && (item.schemetype == "SFTO")) {
        mapedData.sfto_empty_on_run_frequency = item.frequency_period;
        mapedData.sfto_empty_on_run_count = item.value;
        mapedData.sfto_empty_on_run_rake_num = item.rake_number;
        mapedData.sfto_empty_on_run_job_id = item.job_id;
      }
      if (item.parameter == "EMPTY APPROACHING") {
        mapedData.sfto_empty_approaching_frequency = item.frequency_period;
        mapedData.sfto_empty_approaching_count = item.value;
        mapedData.sfto_empty_approaching_rake_num = item.rake_number;
        mapedData.sfto_empty_approaching_job_id = item.job_id;
      }
      if (item.parameter == "UNDER ROH/Maintenance") {
        mapedData.sfto_under_roh_maintenance_frequency = item.frequency_period;
        mapedData.sfto_under_roh_maintenance_count = item.value;
        mapedData.sfto_under_roh_maintenance_rake_num = item.rake_number;
        mapedData.sfto_under_roh_maintenance_job_id = item.job_id;
      }
      if (item.parameter == "CUMMLATIVE UNLOADS") {
        mapedData.sfto_cummulative_unloads_frequency = item.frequency_period;
        mapedData.sfto_cummulative_unloads_count = item.value;
        mapedData.sfto_cummulative_unloads_rake_num = item.rake_number;
        mapedData.sfto_cummulative_unloads_job_id = item.job_id;
      }
      if ((item.parameter == "CUMMLATIVE LOADS") && (item.schemetype == "SFTO")) {
        mapedData.sfto_cummulative_loads_frequency = item.frequency_period;
        mapedData.sfto_cummulative_loads_count = item.value;
        mapedData.sfto_cummulative_loads_rake_num = item.rake_number;
        mapedData.sfto_cummulative_loads_job_id = item.job_id;
      }
      if ((item.parameter == "CUMMLATIVE LOADS") && (item.schemetype == "GPWIS")) {
        mapedData.gpwis_cummulative_loads_frequency = item.frequency_period;
        mapedData.gpwis_cummulative_loads_count = item.value;
        mapedData.gpwis_cummulative_loads_rake_num = item.rake_number;
        mapedData.gpwis_cummulative_loads_job_id = item.job_id;
      }
      if (item.parameter == "LOADS ON RUN" && (item.schemetype == "SFTO")) {
        mapedData.sfto_loads_on_run_frequency = item.frequency_period;
        mapedData.sfto_loads_on_run_today_count = item.value;
        mapedData.sfto_loads_on_run_rake_num = item.rake_number;
        mapedData.sfto_loads_on_run_job_id = item.job_id;
      }
      if (item.parameter == "LOADS ON RUN" && (item.schemetype == "GPWIS")) {
        mapedData.gpwis_loads_on_run_frequency = item.frequency_period;
        mapedData.gpwis_loads_on_run_today_count = item.value;
        mapedData.gpwis_loads_on_run_rake_num = item.rake_number;
        mapedData.gpwis_loads_on_run_job_id = item.job_id;
      }
      if (item.parameter == "mtd_sfto") {
        if (response.records && response.records.length > 0 && response.records[0] && response.records[0].count == '0') {
          mapedData.sfto_target_as_per_project_cumm_ntkm = item.target_as_per_projection_cumm_ntkm_value_data_not_avl;
          mapedData.sfto_target_as_per_project_ntkm_on_date = item.target_as_per_projection_ntkm_on_date_data_not_avl;
          mapedData.sfto_target_as_per_project_monthly_rev = item.target_as_per_projection_monthly_rev_value_data_not_avl;
          mapedData.sfto_target_as_per_project_rev = item.target_as_per_projection_rev_as_on_date_data_not_avl;
          mapedData.sfto_cumm_target_cumm_ntkm = item.cumm_actual_cumm_ntkm_value_data_not_avl;
          mapedData.sfto_cumm_target_ntkm_on_date = item.cumm_actual_ntkm_on_date_data_not_avl;
          mapedData.sfto_cumm_target_monthly_rev = item.cumm_actual_monthly_rev_value_data_not_avl;
          mapedData.sfto_cumm_target_rev = item.cumm_actual_rev_as_on_date_data_not_avl;
        } else {
          console.log('display data which is available');
        }


        mapedData.sfto_mtd_total_fee = item.mtd_total_fee;
        mapedData.sfto_mtd_total_invoice_generated = item.mtd_total_invoice_generated;
        mapedData.sfto_mtd_total_loading_completed = item.mtd_total_loading_completed;
        mapedData.sfto_mtd_total_rr_amount = item.mtd_total_rr_amount;
        mapedData.sfto_mtd_total_rr_count = item.mtd_total_rr_count;
        mapedData.sfto_mtd_total_unloading_completed = item.sfto_mtd_total_unloading_completed;
        mapedData.sfto_mtd_no_of_unloads_tsa = item.mtd_no_of_unloads_sfto_angul;
        mapedData.sfto_mtd_no_of_unloads_tsk = item.mtd_no_of_unloads_sfto_kalinganagar;
        mapedData.sfto_mtd_no_of_unloads_tsj = item.mtd_no_of_unloads_sfto_jamshedpur;
        mapedData.sfto_mtd_no_of_loads_tsa = item.mtd_no_of_loads_sfto_angul;
        mapedData.sfto_mtd_no_of_loads_tsk = item.mtd_no_of_loads_sfto_kalinganagar;
        mapedData.sfto_mtd_no_of_loads_tsj = item.mtd_no_of_loads_sfto_jamshedpur;
        mapedData.sfto_mtd_no_of_invoice_generated_freight_tsa = item.mtd_no_of_invoice_generated_freight_sfto_angul;
        mapedData.sfto_mtd_no_of_invoice_generated_freight_tsk = item.mtd_no_of_invoice_generated_freight_sfto_kalinganagar;
        mapedData.sfto_mtd_no_of_invoice_generated_freight_tsj = item.mtd_no_of_invoice_generated_freight_sfto_jamshedpur;
        mapedData.sfto_mtd_no_of_invoice_generated_fees_tsa = item.mtd_no_of_invoice_generated_fees_sfto_angul;
        mapedData.sfto_mtd_no_of_invoice_generated_fees_tsk = item.mtd_no_of_invoice_generated_fees_sfto_kalinganagar;
        mapedData.sfto_mtd_no_of_invoice_generated_fees_tsj = item.mtd_no_of_invoice_generated_fees_sfto_jamshedpur;
        mapedData.sfto_mtd_no_of_invoice_submitted_freight_tsa = item.mtd_no_of_invoice_submitted_freight_sfto_angul;
        mapedData.sfto_mtd_no_of_invoice_submitted_freight_tsk = item.mtd_no_of_invoice_submitted_freight_sfto_kalinganagar;
        mapedData.sfto_mtd_no_of_invoice_submitted_freight_tsj = item.mtd_no_of_invoice_submitted_freight_sfto_jamshedpur;
        mapedData.sfto_mtd_no_of_invoice_submitted_fees_tsa = item.mtd_no_of_invoice_submitted_fees_sfto_angul;
        mapedData.sfto_mtd_no_of_invoice_submitted_fees_tsk = item.mtd_no_of_invoice_submitted_fees_sfto_kalinganagar;
        mapedData.sfto_mtd_no_of_invoice_submitted_fees_tsj = item.mtd_no_of_invoice_submitted_fees_sfto_jamshedpur;
        mapedData.mtd_inprogress_jobs_for_loads_on_run = item.mtd_inprogress_jobs_for_loads_on_run;
        mapedData.mtd_rake_names_list_loads = item.mtd_rake_names_list_loads;
        mapedData.mtd_rake_names_list_unloads = item.mtd_rake_names_list_unloads;
        mapedData.mtd_inprogress_jobs_rake_names_list = item.mtd_inprogress_jobs_rake_names_list;
        mapedData.mtd_no_of_unloads_gpwis = item.mtd_no_of_unloads_gpwis;
        mapedData.mtd_no_of_unloads_gpwis_rakes_list = item.mtd_no_of_unloads_gpwis_rakes_list;
      }
      if (item.parameter == "mtd_gpwis") {
        mapedData.gpwis_mtd_total_fee = item.mtd_total_fee;
        mapedData.gpwis_mtd_total_invoice_generated = item.mtd_total_invoice_generated;
        mapedData.gpwis_mtd_total_loading_completed = item.mtd_total_loading_completed;
        mapedData.gpwis_mtd_total_rr_amount = item.mtd_total_rr_amount;
        mapedData.gpwis_mtd_total_rr_count = item.mtd_total_rr_count;
        mapedData.gpwis_mtd_total_unloading_completed = item.sfto_mtd_total_unloading_completed;
        mapedData.gpwis_mtd_total_no_of_invoice_generated = item.mtd_total_no_of_invoice_generated_gpwis;
        mapedData.gpwis_mtd_total_no_of_invoice_received = item.mtd_total_no_of_invoice_received_gpwis;
        mapedData.gpwis_mtd_total_no_of_invoice_submitted = item.mtd_total_no_of_invoice_submitted_gpwis;
        mapedData.gpwis_mtd_total_no_of_jobs_created = item.mtd_total_no_of_jobs_created_gpwis;

      }
      if (item.rakes_list) {
        mapedData.rakes_list = item.rakes_list;
      }
    }
    )
    setExecutiveData(mapedData)
  }

  const applicationURL = BuildURL.BuildURL.Environment[BuildURL.BuildURL.Type].RAILWAYS_POWER_BI_URL;
  const applicationDebtorURL = BuildURL.BuildURL.Environment[BuildURL.BuildURL.Type].RAILWAYS_DEBTORS_URL;

  return (
    <>
      <Box py={3}>
        <Grid container spacing={2} justify="space-between">
          <Grid item>
            <PageTitle title={value == 2 ? "Daily Position Report - Railways" : "Dashboard"} />
          </Grid>
          <Grid item xs>
            <Grid container spacing={2} justify='flex-end'>
              <Grid item xs={2}>
                {value == 2 ?
                  <Box>
                    <DateComponent
                      name="daily_date"
                      control={control}
                      rules={{ required: true }}
                      disabled={false}
                      required={true}
                      defaultValue={new Date()}
                      sendminmaxvalue={getMaxDate()}
                      getValueChanged={(value) => {
                        handleDateChange(value)
                      }}
                      error={errors.daily_date}
                      id="daily_date"
                      label="Date"
                    />
                    {errors.daily_date && (
                      <FormValidationErrorMessage
                        errors={errors}
                        errorMessagePrefix="Date"
                        name="daily_date"
                      />
                    )}
                  </Box> :
                  <Box>
                    <AutoCompletecontrler
                      control={control}
                      name="financial_year"
                      id="financial_year"
                      defaultValue={currentFinYear}
                      Values={finYearOptions}
                      disabled={false}
                      // getValueChanged={(data) => financialYearChange(data)}
                      label="Financial Year"
                      fullWidth
                    // required
                    />
                  </Box>
                }
              </Grid>
              <Grid item>
                <Box >
                  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" textColor="primary" indicatorColor="primary" centered className="dashboardTabs">
                    <Tab label="SFTO" {...a11yProps(0)} className={classes.subTextButton} />
                    <Tab label="GPWIS" {...a11yProps(1)} className={classes.subTextButton} />
                    <Tab label="Executive Dashboard" {...a11yProps(2)} className={classes.subTextButton} />
                    <Tab label="Power BI Dashboard" {...a11yProps(3)} className={classes.subTextButton} />
                    <Tab label="Debtors Dashboard" {...a11yProps(4)} className={classes.subTextButton} />
                  </Tabs>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* SFTO */}
      <TabPanel value={value} index={0}>
        <Box py={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Box py={1}>
                <h3 variant="h3" className={classes.secondHeading}>{"SFTO"}</h3>
              </Box>
              <Box py={2} >
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grOne">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">No. of Jobs Loading Completed</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_sfto', 'ytd_total_loading_completed')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_sfto', 'mtd_total_loading_completed')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grTwo">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">No. of Jobs Unloading Completed</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_sfto', 'ytd_total_unloading_completed')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_sfto', 'mtd_total_unloading_completed')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grThree">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">No. of Invoice Generated</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_sfto', 'ytd_total_invoice_generated')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_sfto', 'mtd_total_invoice_generated')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grFour">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">RR Amount</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_sfto', 'ytd_total_rr_amount')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_sfto', 'mtd_total_rr_amount')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grOne">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">Total Fee Amount</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_sfto', 'ytd_total_fee')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_sfto', 'mtd_total_fee')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} sm={7}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"Status Wise Job Summary"}</h3>
              </Box>
              <BarCharter
                doCountByStatus={doCountByStatus} type={'SFTO'}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"SFTO Invoices"}</h3>
              </Box>
              <InvoicesDashboardTable
                allInvoices={allInvoices}
                allSalesOrders={allSalesOrders}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"SFTO Threshold Values"}</h3>
              </Box>
              <TablesSftoThresholdComponent
                sftoThresholdList={sftoThresholdList}
              // allSalesOrders={allSalesOrders}
              />
            </Grid>


            <Grid item xs={12} sm={12}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"SFTO Reports"}</h3>
              </Box>
              <TablesftoReportComponent
                sftoReports={sftoReports}
              // allSalesOrders={allSalesOrders}
              />
            </Grid>
          </Grid>
        </Box>
        <Grid item xs={12} sm={12}>
          <Grid item xs={4} sm={4}>
            {/* <Box py={1}>
              <h3 className={classes.secondHeading}>{"SFTO Job Details"}</h3>
            </Box> */}
          </Grid>
          <Box py={1}>
            <form
              onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
              id="list-job"
              key={resetvalues}
            >
              <Grid container spacing={2} justify='space-between' alignItems='center'>

                <Grid item >
                  <Controller
                    as={<DateRangePicker />}
                    name="rr_start_end_date"
                    control={control}
                    rules={{ required: false }}
                    required={false}
                    disabled={false}
                    onChange={([value]) => {
                      let queryparams = {};
                      let rr_start_end_dates = value.split("To");
                      setSftorrStartDate(rr_start_end_dates
                        ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                        : null);
                      setSftorrEndDate(
                        rr_start_end_dates
                          ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                          : null
                      );
                      return value;
                    }}
                    id="rr_start_end_date"
                    label="RR Date Range"
                  />
                </Grid>
                <Grid item>
                  <Grid container spacing={2} justify='flex-end'>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(
                          classes.subTextButton
                        )}
                        type="submit"
                      >
                        Search
                      </Button>
                    </Grid>

                    <Grid item>

                      <Button
                        variant="outlined"
                        className={clsx(classes.subTextButton)}
                        onClick={resetForm}
                      >
                        Clear
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(
                          classes.subTextButton
                        )}
                        type="button"
                        onClick={generateReport}
                        startIcon={<CloudDownloadIcon />}
                        disabled={disableSftoButton}
                      >
                        Export to Excel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Box>
          {/* <form
          onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
          id="list-job"
          key={resetvalues}
        >
          <Grid item xs={12} sm={6} md={4} lg={3}>

          </Grid>
          <Box pt={1}>
            <Grid container spacing={2} justify="flex-end">
            </Grid>
          </Box>
        </form> */}


          <TableSftoJobDetailsComponent
            loading={loading}
            allSftoJobDetails={allSftoJobDetails}
          />
        </Grid>
      </TabPanel>
      {/* GPWS */}
      <TabPanel value={value} index={1}>
        <Box py={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"GPWIS"}</h3>
              </Box>
              <Box py={2} >
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>

                  {/* <Grid item xs={12} sm>
                    <Paper className="height100 grOne">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">No. of Jobs Loading Completed</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_gpwis', 'ytd_total_loading_completed')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_gpwis', 'mtd_total_loading_completed')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid> */}

                  <Grid item xs={12} sm>
                    <Paper className="height100 grTwo">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">No. of Jobs Created</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_gpwis', 'ytd_total_job_created')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_gpwis', 'mtd_total_job_created')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grThree">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">No. of Invoice Generated</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_gpwis', 'ytd_total_invoice_generated')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_gpwis', 'mtd_total_invoice_generated')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grFour">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">RR Amount</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('ytd_gpwis', 'ytd_total_rr_amount')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_gpwis', 'mtd_total_rr_amount')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Paper className="height100 grOne">
                      <Box p={1} >
                        <Grid container spacing={1}>
                          <Grid item sm>
                            <Box pb={1}>
                              <Typography>
                                <p className="dashboardVertical">Total Fee Amount</p>
                              </Typography>

                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">YTD</p>
                                </Box>
                                <p className="dashboardNumber"><CurrencyFormat value={getCount('ytd_gpwis', 'ytd_total_fee')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>

                              <Grid item xs={6}>
                                <Box >
                                  <p className="dashboardHeading">MTD</p>
                                </Box>
                                <p className="dashboardNumber">
                                  <CurrencyFormat value={getCount('mtd_gpwis', 'mtd_total_fee')} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} />
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sm={7}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"Status Wise Job Summary"}</h3>
              </Box>
              <BarCharter
                doCountByStatus={doCountByStatus2} type={'GPWIS'}
              />
            </Grid>
            {/* <Notifications notify={notify} setNotify={setNotify} /> */}

            <Grid item xs={12} sm={5}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"GPWIS Invoices"}</h3>
              </Box>
              <SalesOrdersDashboardTable
                allInvoices={allInvoices}
                allSalesOrders={allSalesOrders}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Box py={1}>
                <h3 className={classes.secondHeading}>{"GPWIS Reports"}</h3>
              </Box>
              <TablegpwisReportComponent
                gpwisReports={gpwisReports}
              // allSalesOrders={allSalesOrders}
              />
            </Grid>
          </Grid>
        </Box>
        <Grid item xs={12} sm={12}>
          <Grid item xs={4} sm={4}>
            <Box py={1}>
              <h3 className={classes.secondHeading}>{"GPWIS Job Details"}</h3>
            </Box>
          </Grid>
          <Box py={1}>
            <form
              onSubmit={handleSubmit(handleGpwisSearchCriteriaSubmit)}
              id="list-job"
              key={resetvaluesGpwis}
            >
              <Grid container spacing={2} justify='space-between' alignItems='center'>

                <Grid item >
                  <Controller
                    as={<DateRangePicker />}
                    name="rr_start_end_date"
                    control={control}
                    rules={{ required: false }}
                    required={false}
                    disabled={false}
                    onChange={([value]) => {
                      let queryparams = {};
                      let rr_start_end_dates = value.split("To");
                      setGpwisrrStartDate(rr_start_end_dates
                        ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                        : null);
                      setGpwisrrEndDate(
                        rr_start_end_dates
                          ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                          : null
                      );
                      return value;
                    }}
                    id="rr_start_end_date"
                    label="RR Date Range"
                  />
                </Grid>
                <Grid item>
                  <Grid container spacing={2} justify='flex-end'>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(
                          classes.subTextButton
                        )}
                        type="submit"
                      >
                        Search
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        variant="outlined"
                        className={clsx(classes.subTextButton)}
                        onClick={resetFormGpwis}
                      >
                        Clear
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(
                          classes.subTextButton
                        )}
                        type="button"
                        onClick={generateGpwisReport}
                        startIcon={<CloudDownloadIcon />}
                        disabled={disableGpwisButton}
                      >
                        Export to Excel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Box>

          <TableGpwisJobDetailsComponent
            gpwisLoading={gpwisLoading}
            allGpwisJobDetails={allGpwisJobDetails}
          />
        </Grid>
      </TabPanel>
      {/* Executive Dashboard */}
      <TabPanel value={value} index={2}>
        <ExecutiveDashboard
          executiveData={executiveData}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        {/* <Box py={1} 
        // style={{ position: 'absolute', left: "80px", width: '94vw', height: '220px' }} 
        > */}
        <PowerBIEmbed
          embedConfig={{
            type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
            embedUrl: applicationURL,
            accessToken: undefined,
            id: undefined,
            // tokenType: models.TokenType.Embed, 
            // Use models.TokenType.Aad for SaaS embed
            settings: {
              panes: {
                filters: {
                  expanded: "",
                  visible: ""
                }
              },
              // background: models.BackgroundType.Transparent,
            }
          }}
          cssClassName={classes.powerBiContainer}
        />

      </TabPanel>
      <TabPanel value={value} index={4}>
        {/* <Box py={1} 
        // style={{ position: 'absolute', left: "80px", width: '94vw', height: '220px' }} 
        > */}
        <PowerBIEmbed
          embedConfig={{
            type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
            embedUrl: applicationDebtorURL,
            accessToken: undefined,
            id: undefined,
            // tokenType: models.TokenType.Embed, 
            // Use models.TokenType.Aad for SaaS embed
            settings: {
              panes: {
                filters: {
                  expanded: "",
                  visible: ""
                }
              },
              // background: models.BackgroundType.Transparent,
            }
          }}
          cssClassName={classes.powerBiContainer}
        />

      </TabPanel>
    </>
  );
}

// #######################################################################
function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
  var array = new Array(length).fill();
  let lastValue;

  return array.map((item, index) => {
    let randomValue = Math.floor(Math.random() * multiplier + 1);

    while (
      randomValue <= min ||
      randomValue >= max ||
      (lastValue && randomValue - lastValue > maxDiff)
    ) {
      randomValue = Math.floor(Math.random() * multiplier + 1);
    }

    lastValue = randomValue;

    return { value: randomValue };
  });
}

function getMainChartData() {
  var resultArray = [];
  var tablet = getRandomData(31, 3500, 6500, 7500, 1000);
  var desktop = getRandomData(31, 1500, 7500, 7500, 1500);
  var mobile = getRandomData(31, 1500, 7500, 7500, 1500);

  for (let i = 0; i < tablet.length; i++) {
    resultArray.push({
      tablet: tablet[i].value,
      desktop: desktop[i].value,
      mobile: mobile[i].value,
    });
  }

  return resultArray;
}
